module.exports = __webpack_public_path__ + "media/dropdownArrow.e2f96560.svg";